import { customAlphabet } from 'nanoid'

const lowercase = 'abcdefghijklmnopqrstuvwxyz'
const numbers = '0123456789'
export const createChatUUid = customAlphabet(`${lowercase}${numbers}`, 32)
